import { QarepaEnumInformation } from '@qarepa/common';

export enum EmployeeTerminationTypeEnum {
  RESIGNATION = 'RESIGNATION',
  DISMISSAL = 'DISMISSAL',
}

export const EmployeeTerminationTypeArray = [
  EmployeeTerminationTypeEnum.RESIGNATION,
  EmployeeTerminationTypeEnum.DISMISSAL,
];

export const EmployeeTerminationTypeInfo: QarepaEnumInformation<EmployeeTerminationTypeEnum> =
  {
    [EmployeeTerminationTypeEnum.RESIGNATION]: {
      name: $localize`Renuncia`,
    },
    [EmployeeTerminationTypeEnum.DISMISSAL]: {
      name: $localize`Despido`,
    },
  };
